import { COUNTRIES } from '~/config/countries'
import { Options } from '~/components/ui/Inputs/inputHelper'

export const capitalise = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1)
export const capitaliseEachWords = (str: string): string => {
  const arr = str.split(' ')
  for (let i = 0; i < arr.length; i += 1) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
  }
  return arr.join(' ')
}

export const arrayRangeLabelValue = (start: number, stop: number, step: number): Options =>
  Array.from({ length: (stop - start) / step + 1 }, (_, index) => ({
    label: (start + index * step).toString(),
    value: (start + index * step).toString(),
  }))

export const snakeCaseReplacer = (stringValue, replaceBy = ' ') => {
  return stringValue.replace('_', replaceBy)
}

export const snakeCaseAndDisplayHandler = (stringValue) => {
  return capitaliseEachWords(snakeCaseReplacer(stringValue))
}

export const toSnakeCase = (stringValue) => {
  return stringValue
    .toLowerCase()
    .replace(/[^a-zA-Z ]/g, '')
    .replace(/ /g, '_')
}

export const getDemandwareUrl = (mhjEnvironment) => {
  /* NOTE: Used for DIS, images contexts, otherwise dev and prod URLs are
   * subject to Salesforce's Origin Shielding */
  switch (mhjEnvironment) {
    case 'prod':
      return 'https://production-web-michaelhill.demandware.net'
    case 'stage':
      return 'https://edge.disstg.commercecloud.salesforce.com'
    case 'dev':
      return 'https://development-web-michaelhill.demandware.net'
    case 'dev2':
      return 'https://aanc-001.dx.commercecloud.salesforce.com'
    case 'ods3':
      return 'https://aanc-003.dx.commercecloud.salesforce.com'
    default:
      return `https://${mhjEnvironment}-web-michaelhill.demandware.net`
  }
}

export const getSfccImageUrl = (mhjEnvironment, isConstructor = false) => {
  switch (mhjEnvironment) {
    case 'prod':
      return `https://prod-sfcc-api.michaelhill.com${isConstructor ? '/dw/image/v2/AANC_PRD' : ''}`
    case 'stage':
      return `https://edge.disstg.commercecloud.salesforce.com${isConstructor ? '/dw/image/v2/AANC_STG' : ''}`
    case 'dev':
    case 'dev2': // Constructor Integration: Dev2 is loading product data from Development
      return `https://dev-sfcc-api.michaelhill.com${isConstructor ? '/dw/image/v2/AANC_DEV' : ''}`
    default:
      return 'https://staging-web-michaelhill.demandware.net'
  }
}

export const formatDate = (date: Date | string, locale: 'en-AU' | 'en-CA' | 'en-NZ' | 'fr-CA') => {
  if (!date) return ''
  const d = new Date(date)
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }
  return new Intl.DateTimeFormat(locale, options).format(d)
}

export function formatDateDDMMYYYY(day: string, month: string, year: string) {
  const formatOption = {
    minimumIntegerDigits: 2,
  }
  const formatTwoDigits = (val: string) => new Intl.NumberFormat('en', formatOption).format(Number(val))
  const formattedBirthdayDay = formatTwoDigits(day)
  const formattedBirthdayMonth = formatTwoDigits(month)
  //Format the date to YYYY-MM-DD
  return `${year}-${formattedBirthdayMonth}-${formattedBirthdayDay}`
}

export const formatBirthMonth = (month: string) => formatDateDDMMYYYY('1', month, '1900')

export const countryName = (countryCode?: string) => {
  if (!countryCode) return ''
  return COUNTRIES.find((country) => country.iso === countryCode)?.name || countryCode
}

export function isTouchEnabled(): boolean {
  return matchMedia('(pointer: coarse)').matches
}
